module.exports = __webpack_public_path__ + "static/media/IMG_2567.78bfbb61.jpg";